import Vue from 'vue'
import 'normalize.css'
import './common/main.css'
import './common/reportable.scss'
import './plugins/axios'
import Message from 'vue-m-message'
import '@vant/touch-emulator'
// import { Dialog, Notify, Toast } from 'vant'
import Vant from 'vant'
import 'vant/lib/index.css'
import './common/jsbridge'
import './common/umeng'
import './common/tracking'
import './common/util'
import './common/print'
import App from './App.vue'
import router from './router'
import { install } from 'vs-tree'
import 'vs-tree/dist/vs-tree.css'
import VueVirtualScroller from 'vue-virtual-scroller'
import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta&&to.meta.title) {
      document.title = to.meta.title;//title的默认值为农发贷
    }else{
      document.title = '智慧产业链';
    }
    next();
});
Vue.use(VueVirtualScroller);
Vue.use(Message);
Vue.$message = Message;
Vue.use(install);
// Vue.use(Dialog, Notify, Toast);
Vue.use(Vant);

Vue.config.productionTip = false;
Vue.filter('toThousands', function(value) {
    return Vue.$util.toThousands(value);
});
Vue.filter('formatDate', function(value, fmt, forEng) {
    if(!value){
        return '--';
    }
    return Vue.$util.formatDate(value, fmt||'yyyy-MM-dd', forEng);
});
Vue.filter('emptyText', function(value) {
  if(typeof(value) == 'number' || typeof(value) == 'string') {
    return value;
  } else {
    return '--';
  }
});
Vue.directive('decimal', {
  bind(el, binding) {
    const decimalPlaces = binding.value || 3; // 默认限制 3 位小数

    el.addEventListener('input', function (e) {
      let val = e.target.value
        .replace(/[^0-9.]/g, '')
        .replace(/\.{2,}/g, '.');
      val = val.replace(/(\..*)\./g, '$1'); // 确保只有一个点号

      const parts = val.split('.');
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, decimalPlaces); // 限制小数位数
        val = parts.join('.');
      }
      if (val.startsWith('.')) {
        val = '0' + val;
      }

      e.target.value = val;
      // e.target.dispatchEvent(new Event("input")); 
    });
  }
});
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

//软键盘遮挡输入框的问题
if(navigator.userAgent.indexOf('_demeter/') != -1) {//flutter_webview_plugin加载的
  if(!/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {//ios没问题
    document.addEventListener('focus', (event) => {
      let target = event.target;
      if((target.nodeName.toLowerCase()=='input' && target.getAttribute('type')!='radio' && target.getAttribute('type')!='checkbox') || target.nodeName.toLowerCase() == 'textarea') {
        if(!target.getAttribute('readonly') && !target.getAttribute('disabled')) {
          setTimeout(() => {
            target.scrollIntoView();
          }, 200);
        }
      }
    }, true);
  }
}
